export type asyncForEachCallbackType<T> = (item: T, index: number, array: T[]) => Promise<void>
export async function forEachAsync<T>(
  array: T[] | null,
  callback: asyncForEachCallbackType<T>,
  options?: { continueCondition?: () => boolean; sort?: 'asc' | 'desc'; skip?: number; size?: number },
): Promise<{ hasCurrent: boolean; hasNext: boolean }> {
  if (array) {
    const { continueCondition = () => true, sort = 'asc', skip = 0, size = array.length } = options || {}
    const length = Math.min(skip + size, array.length)
    if (skip >= array.length) {
      return {
        hasCurrent: false,
        hasNext: false,
      }
    }
    if (sort === 'desc') {
      for (let index = length - 1; index >= skip && continueCondition(); index -= 1) {
        await callback(array[index], index, array)
      }
    } else {
      for (let index = skip; index < length && continueCondition(); index += 1) {
        await callback(array[index], index, array)
      }
    }

    if (length === array.length) {
      return {
        hasCurrent: true,
        hasNext: false,
      }
    }

    return {
      hasCurrent: true,
      hasNext: true,
    }
  }

  return {
    hasCurrent: false,
    hasNext: false,
  }
}
